import React, { useState } from 'react';
import { 
  Building2, User, MapPin, Phone, Mail, Search, Plus, Edit, Trash2, 
  ChevronLeft, ChevronRight, Filter, X, Save, Clock, Award, IdCard,
  Users, Settings, Eye, UserPlus, Building, AlertCircle
} from 'lucide-react';

const PharmacyManagementSobre = () => {
  const [activeTab, setActiveTab] = useState('pharmacies');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    city: 'all',
    status: 'all',
    pharmacy: 'all'
  });

  const itemsPerPage = 10;

  const [pharmacies, setPharmacies] = useState([
    { id: 1, name: 'Pharmacie Dakar Centre', city: 'Dakar', address: 'Avenue Léopold Sédar Senghor', phone: '+221 77 123 45 67', email: 'contact@pharmaciedakar.sn', pharmacist: 'Dr. Fatou Ndiaye', pharmacistId: 1, openingHours: '8h - 20h', status: 'active', staffCount: 5 },
    { id: 2, name: 'Pharmacie Thies Nord', city: 'Thies', address: 'Route Nationale 2', phone: '+221 77 234 56 78', email: 'pharmaciethies@gmail.com', pharmacist: 'Dr. Amadou Diop', pharmacistId: 2, openingHours: '8h - 21h', status: 'active', staffCount: 3 },
    { id: 3, name: 'Pharmacie Mbour Plage', city: 'Mbour', address: 'Front de mer, Mbour', phone: '+221 77 345 67 89', email: 'pharma.mbour@orange.sn', pharmacist: 'Non assigné', pharmacistId: null, openingHours: '7h30 - 22h', status: 'incomplete', staffCount: 2 },
    { id: 4, name: 'Pharmacie Saint-Louis', city: 'Saint-Louis', address: 'Rue de France', phone: '+221 77 456 78 90', email: 'pharma.stlouis@gmail.com', pharmacist: 'Non assigné', pharmacistId: null, openingHours: '8h - 19h', status: 'incomplete', staffCount: 4 },
    { id: 5, name: 'Pharmacie Rufisque Centre', city: 'Rufisque', address: 'Avenue Blaise Diagne', phone: '+221 77 567 89 01', email: 'contact@pharmarufisque.sn', pharmacist: 'Dr. Khady Ba', pharmacistId: 5, openingHours: '8h - 20h', status: 'active', staffCount: 3 },
  ]);

  const [pharmacists, setPharmacists] = useState([
    { id: 1, firstName: 'Fatou', lastName: 'Ndiaye', email: 'f.ndiaye@pharmacie.sn', phone: '+221 77 123 45 67', specialization: 'Pharmacie Clinique', licenseNumber: 'SN-PHR-2015-001234', pharmacy: 'Pharmacie Dakar Centre', pharmacyId: 1, status: 'active' },
    { id: 2, firstName: 'Amadou', lastName: 'Diop', email: 'a.diop@pharmacie.sn', phone: '+221 77 234 56 78', specialization: 'Pharmacie Hospitalière', licenseNumber: 'SN-PHR-2018-002345', pharmacy: 'Pharmacie Thies Nord', pharmacyId: 2, status: 'active' },
    { id: 3, firstName: 'Aïssa', lastName: 'Fall', email: 'a.fall@pharmacie.sn', phone: '+221 77 345 67 89', specialization: 'Pharmacie Communautaire', licenseNumber: 'SN-PHR-2016-003456', pharmacy: 'Non assigné', pharmacyId: null, status: 'incomplete' },
    { id: 4, firstName: 'Moussa', lastName: 'Sarr', email: 'm.sarr@pharmacie.sn', phone: '+221 77 456 78 90', specialization: 'Pharmacologie', licenseNumber: 'SN-PHR-2019-004567', pharmacy: 'Non assigné', pharmacyId: null, status: 'incomplete' },
    { id: 5, firstName: 'Khady', lastName: 'Ba', email: 'k.ba@pharmacie.sn', phone: '+221 77 567 89 01', specialization: 'Pharmacie Industrielle', licenseNumber: 'SN-PHR-2017-005678', pharmacy: 'Pharmacie Rufisque Centre', pharmacyId: 5, status: 'active' },
  ]);

  const getFilteredData = () => {
    const data = activeTab === 'pharmacies' ? pharmacies : pharmacists;
    
    return data.filter(item => {
      const matchesSearch = activeTab === 'pharmacies' 
        ? item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.pharmacist.toLowerCase().includes(searchTerm.toLowerCase())
        : `${item.firstName} ${item.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.pharmacy.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesStatus = filters.status === 'all' || item.status === filters.status;

      return matchesSearch && matchesStatus;
    });
  };

  const filteredData = getFilteredData();
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleDelete = (id) => {
    if (activeTab === 'pharmacies') {
      const pharmacy = pharmacies.find(p => p.id === id);
      if (pharmacy.pharmacistId) {
        alert(`Impossible de supprimer ${pharmacy.name}\n\nCette pharmacie a un pharmacien responsable assigné.`);
        return;
      }
      if (window.confirm(`Êtes-vous sûr de vouloir supprimer ${pharmacy.name} ?`)) {
        setPharmacies(prev => prev.filter(p => p.id !== id));
        alert('Pharmacie supprimée');
      }
    } else {
      const pharmacist = pharmacists.find(p => p.id === id);
      if (pharmacist.pharmacyId) {
        alert(`Impossible de supprimer Dr. ${pharmacist.firstName} ${pharmacist.lastName}\n\nCe pharmacien est responsable de ${pharmacist.pharmacy}.`);
        return;
      }
      if (window.confirm(`Êtes-vous sûr de vouloir supprimer Dr. ${pharmacist.firstName} ${pharmacist.lastName} ?`)) {
        setPharmacists(prev => prev.filter(p => p.id !== id));
        alert('Pharmacien supprimé');
      }
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      active: { bg: 'bg-green-100', text: 'text-green-700', label: 'Actif', border: 'border-green-200' },
      incomplete: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Incomplet', border: 'border-yellow-200' },
      inactive: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Inactif', border: 'border-gray-200' }
    };
    return badges[status] || badges.active;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="p-6">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
              <Building2 className="text-white" size={24} />
            </div>
            
            <div className="flex-1">
              <h1 className="text-2xl font-bold text-gray-900">Gestion du Réseau</h1>
              <p className="text-gray-600 text-sm">Pharmacies et Pharmaciens</p>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Pharmacies</p>
                <p className="text-3xl font-bold text-gray-900">{pharmacies.length}</p>
              </div>
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                <Building2 className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Pharmaciens</p>
                <p className="text-3xl font-bold text-gray-900">{pharmacists.length}</p>
              </div>
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                <Users className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Assignés</p>
                <p className="text-3xl font-bold text-green-600">
                  {pharmacists.filter(p => p.pharmacyId !== null).length}
                </p>
              </div>
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center">
                <User className="text-white" size={24} />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Disponibles</p>
                <p className="text-3xl font-bold text-blue-600">
                  {pharmacists.filter(p => p.pharmacyId === null).length}
                </p>
              </div>
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                <UserPlus className="text-white" size={24} />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          {/* Tabs */}
          <div className="border-b border-gray-200 bg-gray-50">
            <div className="flex">
              <button
                onClick={() => { setActiveTab('pharmacies'); setCurrentPage(1); }}
                className={`flex items-center space-x-2 px-6 py-4 font-medium transition-all ${
                  activeTab === 'pharmacies'
                    ? 'bg-white text-green-600 border-b-2 border-green-600'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Building2 size={20} />
                <span>Pharmacies</span>
                <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-bold">
                  {pharmacies.length}
                </span>
              </button>
              <button
                onClick={() => { setActiveTab('pharmacists'); setCurrentPage(1); }}
                className={`flex items-center space-x-2 px-6 py-4 font-medium transition-all ${
                  activeTab === 'pharmacists'
                    ? 'bg-white text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Users size={20} />
                <span>Pharmaciens</span>
                <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-bold">
                  {pharmacists.length}
                </span>
              </button>
            </div>
          </div>

          {/* Filters Bar */}
          <div className="p-6 border-b border-gray-200 bg-gray-50">
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
              {/* Search */}
              <div className="flex-1 w-full md:w-auto">
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    placeholder={`Rechercher ${activeTab === 'pharmacies' ? 'une pharmacie' : 'un pharmacien'}...`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Filters */}
              <div className="flex gap-3 w-full md:w-auto flex-wrap">
                <select
                  value={filters.status}
                  onChange={(e) => setFilters({...filters, status: e.target.value})}
                  className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 bg-white"
                >
                  <option value="all">Tous les statuts</option>
                  <option value="active">Actif</option>
                  <option value="incomplete">Incomplet</option>
                  <option value="inactive">Inactif</option>
                </select>

                <button
                  onClick={() => alert('Fonctionnalité pas encore disponible')}
                  className={`flex items-center space-x-2 px-6 py-3 text-white rounded-lg hover:shadow-md transition-all font-medium whitespace-nowrap ${
                    activeTab === 'pharmacies' ? 'bg-green-600 hover:bg-green-700' : 'bg-blue-600 hover:bg-blue-700'
                  }`}
                >
                  <Plus size={20} />
                  <span>Ajouter</span>
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  {activeTab === 'pharmacies' ? (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacie</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Ville</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacien</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Contact</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Statut</th>
                      <th className="px-6 py-3 text-right text-xs font-bold text-gray-700 uppercase">Actions</th>
                    </>
                  ) : (
                    <>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacien</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Spécialisation</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">N° Licence</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Pharmacie</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-700 uppercase">Statut</th>
                      <th className="px-6 py-3 text-right text-xs font-bold text-gray-700 uppercase">Actions</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {paginatedData.map((item) => {
                  const badge = getStatusBadge(item.status);
                  
                  return activeTab === 'pharmacies' ? (
                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center flex-shrink-0">
                            <Building2 className="text-white" size={20} />
                          </div>
                          <div>
                            <p className="font-bold text-gray-900">{item.name}</p>
                            <p className="text-sm text-gray-500">{item.address}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="flex items-center space-x-1 text-gray-700">
                          <MapPin size={16} className="text-gray-400" />
                          <span className="font-medium">{item.city}</span>
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          {item.pharmacistId ? (
                            <>
                              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <User size={16} className="text-blue-600" />
                              </div>
                              <span className="text-sm font-medium text-gray-900">{item.pharmacist}</span>
                            </>
                          ) : (
                            <button
                              onClick={() => alert('Fonctionnalité pas encore disponible')}
                              className="flex items-center space-x-1 text-blue-600 hover:text-blue-700 text-sm font-semibold"
                            >
                              <UserPlus size={16} />
                              <span>Assigner</span>
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <a href={`tel:${item.phone}`} className="flex items-center space-x-1 text-sm text-gray-600 hover:text-blue-600">
                          <Phone size={14} />
                          <span>{item.phone}</span>
                        </a>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 ${badge.bg} ${badge.text} rounded-full text-xs font-medium border ${badge.border}`}>
                          {badge.label}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end space-x-2">
                          <button
                            onClick={() => alert('Fonctionnalité pas encore disponible')}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                            title="Modifier"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                            title="Supprimer"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                            <User className="text-white" size={20} />
                          </div>
                          <div>
                            <p className="font-bold text-gray-900">Dr. {item.firstName} {item.lastName}</p>
                            <p className="text-sm text-gray-500">{item.email}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="flex items-center space-x-1 text-sm">
                          <Award size={16} className="text-gray-400" />
                          <span className="font-medium text-gray-700">{item.specialization}</span>
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="font-mono text-sm text-gray-600">{item.licenseNumber}</span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          {item.pharmacyId ? (
                            <>
                              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                                <Building size={16} className="text-green-600" />
                              </div>
                              <span className="text-sm font-medium text-gray-900">{item.pharmacy}</span>
                            </>
                          ) : (
                            <span className="text-sm text-gray-400 italic">Non assigné</span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 ${badge.bg} ${badge.text} rounded-full text-xs font-medium border ${badge.border}`}>
                          {badge.label}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-end space-x-2">
                          <button
                            onClick={() => alert('Fonctionnalité pas encore disponible')}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all"
                            title="Modifier"
                          >
                            <Edit size={18} />
                          </button>
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all"
                            title="Supprimer"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-between">
              <div className="text-sm text-gray-600">
                Affichage de {((currentPage - 1) * itemsPerPage) + 1} à{' '}
                {Math.min(currentPage * itemsPerPage, filteredData.length)} sur{' '}
                {filteredData.length} résultats
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  <ChevronLeft size={20} />
                </button>
                
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-4 py-2 rounded-lg font-bold transition-all ${
                      currentPage === i + 1
                        ? 'bg-green-600 text-white'
                        : 'border border-gray-300 hover:bg-gray-100'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
            </div>
          )}

          {/* Empty State */}
          {filteredData.length === 0 && (
            <div className="text-center py-12">
              {activeTab === 'pharmacies' ? (
                <Building2 size={48} className="mx-auto text-gray-300 mb-4" />
              ) : (
                <Users size={48} className="mx-auto text-gray-300 mb-4" />
              )}
              <p className="text-gray-500 text-lg">Aucun résultat trouvé</p>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PharmacyManagementSobre;